import { Navigate } from 'react-router-dom';
import { useDoctorRole } from '../hook/useDoctorRole';

const DoctorRoute = ({ component: Component, ...rest }) => {
  const { isDoctor, isAdmin, isSuperAdmin, isLoading } = useDoctorRole();
  // console.log("useDoctorRole isDoctor:", isDoctor);
  // console.log("useDoctorRole isAdmin:", isAdmin);
  // console.log("useDoctorRole isSuperAdmin:", isSuperAdmin);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (isDoctor || isAdmin || isSuperAdmin) ? <Component {...rest} /> : <Navigate to="/login" replace />;
};

export default DoctorRoute;